<section class="article-component-cont">
	<header>
		<h3 class="ent-color"><i class="fas fa-file-alt" aria-hidden="true"></i>Contract information</h3>
	</header>
	<div class="article-content contract-info">
		<!-- contract information table -->
		<ng-content></ng-content>
	</div>
</section>
